import React, { Component } from 'react';
import ApiService from '../../service/ApiService';
import { Table } from 'react-bootstrap';
import { convertToInternationalCurrencySystem } from '../../service/Util';
import MediaQuery from 'react-responsive';

const isMobile = window.screen.width < 500;

class StockProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            outlook: {},
            sharesFLoat: {},
            symbol: this.props.symbol
        };
    }

    componentDidMount() {
        console.log('windowsize', isMobile, window.screen.width);
        ApiService.getCompanyOutlook(this.state.symbol).then(result => {
            console.log('Company Outlook', result);
            // this.setState({ outlook: result });

            if (result !== null && result !== undefined) {
                ApiService.getSharesFloat(this.state.symbol)
                    .then(result1 => {
                        console.log('Shares Float', result1);
                        this.setState({ outlook: result, sharesFLoat: result1 });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        })
            .catch((error) => {
                console.log(error);
            });
    }

    roundOff(value, noOfDecimal) {
        return parseFloat(value).toFixed(noOfDecimal);
    }

    getLatestRatio(outlook) {
        let ratio = {
            dividendYielPercentageTTM: '',
            peRatioTTM: '',
            cashPerShareTTM: '',
            dividendPerShareTTM: ''

        }
        if (outlook !== null && outlook.ratios !== undefined && outlook.ratios.length > 0) {
            let tmpRatio = outlook.ratios[0];
            ratio.dividendYielPercentageTTM = this.roundOff(tmpRatio.dividendYielPercentageTTM, 2);
            ratio.peRatioTTM = this.roundOff(tmpRatio.peRatioTTM, 2);
            ratio.dividendPerShareTTM = this.roundOff(tmpRatio.dividendPerShareTTM, 2);
            ratio.cashPerShareTTM = this.roundOff(tmpRatio.cashPerShareTTM, 2);
        }
        return ratio;
    }

    getLatestIncome(outlook) {
        let obj = {
            netIncome: '',

        }
        if (outlook !== null && outlook.financialsAnnual !== undefined && outlook.financialsAnnual.income !== undefined && outlook.financialsAnnual.income.length > 0) {
            let tmpObj = outlook.financialsAnnual.income[0];
            obj.netIncome = convertToInternationalCurrencySystem(tmpObj.netIncome);
        }
        return obj;
    }

    getSharesFloat(sharesFloat) {
        let obj = {
            floatShares: '',
        }
        if (sharesFloat !== null && sharesFloat !== undefined && sharesFloat.length > 0) {
            let tmpObj = sharesFloat[0];
            obj.shareFloat = convertToInternationalCurrencySystem(tmpObj.floatShares);
        }
        return obj;
    }

    render() {
        if (this.state === null) {
            return <div>Loading...</div>
        }
        if (this.state.outlook === undefined || this.state.outlook.profile === undefined) {
            return <div>No Data</div>
        }
        console.log('stock profile', this.state.outlook.profile);
        let changes = this.roundOff(this.state.outlook.profile.changes, 2);
        let ratio = this.getLatestRatio(this.state.outlook);
        let income = this.getLatestIncome(this.state.outlook);
        let sharesFloat = this.getSharesFloat(this.state.sharesFLoat);
        let dividendPercentage = isNaN(ratio.dividendYielPercentageTTM) ? '' : ratio.dividendYielPercentageTTM + '%';
        let dividend = isNaN(ratio.dividendPerShareTTM) ? '' : ratio.dividendPerShareTTM;
        let cashpersh = isNaN(this.state.outlook.profile.dcf) ? '' : this.state.outlook.profile.dcf;
        let website = '';
        if (this.state.outlook.profile.website !== undefined && this.state.outlook.profile.website !== null && this.state.outlook.profile.website !== ''){
            website = this.state.outlook.profile.website.toString().replace('https://', '');
        }

        return (
            <div>
                Stock Profile
                <MediaQuery minWidth={900}>
                    <Table bordered hover size="xs" style={{ fontSize: "10px", backgroundColor: '#F8F8F8' }}>
                        <tbody>
                            <tr key={100}>
                                <td>Name</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.companyName}</td>
                                <td>Country</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.country}</td>
                                <td>website</td><td style={{ fontWeight: 'bold' }}>{website}</td>
                                <td>CEO</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.ceo}</td>
                            </tr>
                            <tr key={200}>
                                <td>Exchange</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.exchangeShortName}</td>
                                <td>Mkt Cap</td><td style={{ fontWeight: 'bold' }}>{convertToInternationalCurrencySystem(this.state.outlook.profile.mktCap)}</td>
                                <td>Sector</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.sector}</td>
                                <td>Employees</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.fullTimeEmployees}</td>
                            </tr>
                            <tr key={300}>
                                <td>Range</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.range}</td>
                                <td>Beta</td><td style={{ fontWeight: 'bold' }}>{this.roundOff(this.state.outlook.profile.beta, 2)}</td>
                                <td>Vol. Avg</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.volAvg}</td>
                                <td>Changes</td><td style={{ fontWeight: 'bold' }}>{changes}</td>
                            </tr>
                            <tr key={400}>
                                <td>Dis. cash flow</td><td style={{ fontWeight: 'bold' }}>{cashpersh}</td>
                                <td>ISIN</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.isin}</td>
                                <td>Dividend %</td><td style={{ fontWeight: 'bold' }}>{dividendPercentage}</td>
                                <td>Dividend</td><td style={{ fontWeight: 'bold' }}>{dividend}</td>
                            </tr>
                            <tr key={500}>
                                <td>Income</td><td style={{ fontWeight: 'bold' }}>{income.netIncome}</td>
                                <td>P/E</td><td style={{ fontWeight: 'bold' }}>{ratio.peRatioTTM}</td>
                                <td>Cash/Sh</td><td style={{ fontWeight: 'bold' }}>{ratio.cashPerShareTTM}</td>
                                <td>Sh Float</td><td style={{ fontWeight: 'bold' }}>{sharesFloat.shareFloat}</td>
                            </tr>
                        </tbody>
                    </Table>
                </MediaQuery>

                <MediaQuery maxWidth={899}>
                    <Table bordered hover size="xs" style={{ fontSize: "10px", backgroundColor: '#F8F8F8' }}>
                        <tbody>
                            <tr key={100}>
                                <td>Name</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.companyName}</td>
                                <td>Country</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.country}</td>
                            </tr>
                            <tr key={200}>
                                <td>Exchange</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.exchangeShortName}</td>
                                <td>Mkt Cap</td><td style={{ fontWeight: 'bold' }}>{convertToInternationalCurrencySystem(this.state.outlook.profile.mktCap)}</td>
                            </tr>
                            <tr key={300}>
                                <td>Range</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.range}</td>
                                <td>Beta</td><td style={{ fontWeight: 'bold' }}>{this.roundOff(this.state.outlook.profile.beta, 2)}</td>
                            </tr>
                            <tr key={400}>
                                <td>Dis. cash flow</td><td style={{ fontWeight: 'bold' }}>{cashpersh}</td>
                                <td>ISIN</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.isin}</td>
                            </tr>
                            <tr key={500}>
                                <td>Income</td><td style={{ fontWeight: 'bold' }}>{income.netIncome}</td>
                                <td>P/E</td><td style={{ fontWeight: 'bold' }}>{ratio.peRatioTTM}</td>
                            </tr>
                        </tbody>
                    </Table>

                    <Table bordered hover size="xs" style={{ fontSize: "10px", backgroundColor: '#F8F8F8' }}>
                        <tbody>
                            <tr key={600}>
                                <td>website</td><td style={{ fontWeight: 'bold' }}>{website}</td>
                                <td>CEO</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.ceo}</td>
                            </tr>
                            <tr key={700}>
                                <td>Sector</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.sector}</td>
                                <td>Employees</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.fullTimeEmployees}</td>
                            </tr>
                            <tr key={800}>
                                <td>Vol. Avg</td><td style={{ fontWeight: 'bold' }}>{this.state.outlook.profile.volAvg}</td>
                                <td>Changes</td><td style={{ fontWeight: 'bold' }}>{changes}</td>
                            </tr>
                            <tr key={900}>
                                <td>Dividend %</td><td style={{ fontWeight: 'bold' }}>{dividendPercentage}</td>
                                <td>Dividend</td><td style={{ fontWeight: 'bold' }}>{dividend}</td>
                            </tr>
                            <tr key={1000}>
                                <td>Cash/Sh</td><td style={{ fontWeight: 'bold' }}>{ratio.cashPerShareTTM}</td>
                                <td>Sh Float</td><td style={{ fontWeight: 'bold' }}>{sharesFloat.shareFloat}</td>
                            </tr>
                        </tbody>
                    </Table>
                </MediaQuery>
            </div>
        );
    }
}

export default StockProfile;
